import { Navigate } from 'react-router-dom';

export default function InventoryPage() {
  return <Navigate to="/inventory/search" replace />;
}
